import { PartnerConfig } from '../types';

const EMPTY_FAVICON = 'data:,';

function setFavicon(href: string) {
  const favicon =
    (document.querySelector("link[rel='icon']") as HTMLLinkElement | null) ||
    (document.querySelector(
      "link[rel='shortcut icon']",
    ) as HTMLLinkElement | null);

  if (favicon) {
    favicon.href = href;
    return;
  }

  const link = document.createElement('link');
  link.rel = 'icon';
  link.href = href;
  document.head.appendChild(link);
}

export function applyPartnerTheme(partnerConfig: PartnerConfig | null) {
  const googleFontLink = document.querySelector(
    "link[data-partner-font='true']",
  ) as HTMLLinkElement | null;

  if (!partnerConfig) {
    document.title = '';
    setFavicon(EMPTY_FAVICON);

    if (googleFontLink) {
      googleFontLink.remove();
    }

    return;
  }

  const baseFont = partnerConfig.theme?.fonts?.base;
  if (baseFont) {
    document.body.style.fontFamily = baseFont;
    document.documentElement.style.setProperty('--wl-font-base', baseFont);
  }

  document.title =
    partnerConfig.theme?.title?.trim() || partnerConfig.name?.trim() || '';

  if (partnerConfig.palette) {
    Object.entries(partnerConfig.palette).forEach(([key, value]) => {
      if (!value) return;
      document.documentElement.style.setProperty(`--wl-${key}`, value);
    });
  }

  setFavicon(partnerConfig.theme?.favicon_url || EMPTY_FAVICON);

  const googleFontUrl = partnerConfig.theme?.google_font;

  if (googleFontUrl) {
    const link = googleFontLink ?? document.createElement('link');
    link.rel = 'stylesheet';
    link.href = googleFontUrl;
    link.setAttribute('data-partner-font', 'true');
    if (!googleFontLink) {
      document.head.appendChild(link);
    }
  } else if (googleFontLink) {
    googleFontLink.remove();
  }
}
